import React from 'react';
import ReactDOM from 'react-dom';
import "./App.css";
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom';

import App from './container/App';

import { GlobalStyle } from './styles';
import 'typeface-roboto';

const setFavicon = () => {
  const app = process.env.REACT_APP_CURRENT_APPLICATION;

  let favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;

  if (!favicon) {
    favicon = document.createElement('link') as HTMLLinkElement;
    favicon.rel = 'icon';
    document.head.appendChild(favicon);
  }

  favicon.href = `${process.env.PUBLIC_URL}/${app === 'GLOBO' ? 'favicon.ico' : 'favicon-mediapro.ico'}`;
};

setFavicon();

ReactDOM.render(
  <>
    <BrowserRouter>
      <App />
      <GlobalStyle />
    </BrowserRouter>
  </>,
  document.getElementById('root')
);

reportWebVitals();
